import { IRoute } from "@src/routes";
import ListOrderPage from '@we/orders/pages/ListOrdersPage';

const routes: IRoute[] = [
    {
        menu: { label: "Pedidos" },
        path: "/we/orders",
        key: "WE_ORDER_LIST",
        exact: true,
        component: ListOrderPage,
    }
];


export default routes;
